export default "__VITE_ASSET__2e93ab13__"